import * as React from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';
import styles from './switch.module.css';
import { cn } from '@/lib/utils';

function Switch(
  props: React.ComponentProps<typeof SwitchPrimitive.Root> & {
    size?: 'xs' | 'sm' | 'md' | 'lg';
    variant?: 'primary' | 'success' | 'danger' | 'neutral';
  }
) {
  const { size = 'md', variant = 'primary', className, ...rest } = props;

  const sizeClasses = {
    xs: styles.customSwitchXs,
    sm: styles.customSwitchSm,
    md: styles.customSwitchMd,
    lg: styles.customSwitchLg,
  };

  const variantClasses = {
    primary: styles.customSwitchPrimary,
    success: styles.customSwitchSuccess,
    danger: styles.customSwitchDanger,
    neutral: styles.customSwitchNeutral,
  };

  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      data-size={size}
      data-variant={variant}
      className={cn(
        styles.customSwitch,
        sizeClasses[size],
        variantClasses[variant],
        className
      )}
      {...rest}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={styles.customSwitchThumb}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
